import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styles from './Subscription.module.css'; // ایمپورت ماژول CSS
import { BsChevronLeft } from 'react-icons/bs';
import api from '../../services/axiosConfig';
import { BASE_URL, BAZAAR_INITPAYMENT, BAZAAR_VERIFYPAYMENT, USER_SUBSCRIPTION } from '../../constant-value';
import { useSelector } from 'react-redux';
import SpinnerWrapper from '../../conponents/pages/spinnerWrapper';
import { PuffLoader } from 'react-spinners';
import BottomSheet from '../../conponents/bottom-sheet/bottom-sheet';
import SubscriptionBS from './subscriptionBS';
import { toast } from 'react-toastify';
import { useRef } from 'react';

const Subscription = () => {
  const user = useSelector((state) => state.user.user);
  const [transactions, setTransactions] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenBS, setIsOpenBS] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const handledRef = useRef(false);



  const fetchSubscriptions = () => {
    setIsLoading(true);
    api
      .get(`/${USER_SUBSCRIPTION}${user.userId}`)
      .then((result) => {
        const list = result.data?.subscriptions || [];
        setTransactions(list);
      })
      .catch((error) => console.log("catch: ", error))
      .finally(() => setIsLoading(false));
  };
  

  const location = useLocation();
  const navigate = useNavigate();

  const toggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  // حذف نشود! راهنمای فیلد های کارت
  // const transactions = [
  //   {
  //     id: 1,
  //     date: "1404/03/22 - 11:59",
  //     amount: "99,000",
  //     title: "اشتراک یکساله",
  //     subtitle: "اعتبار تا 1405/03/22",
  //   }
  // ];
  // دریافت اطلاعات کاربر
  useEffect(() => {
    fetchSubscriptions();
  }, [user.userId]);


  const canPayment =
  Array.isArray(transactions) && transactions.every(item => item.canPayment === true);
  // transactions.some(item => item.canPayment === false);

  const paymentOnline=(p)=>{
    pay(p);
  }

  const pay = async (p) => {
      api.post(`${BAZAAR_INITPAYMENT}`, {
        plan: p,
        redirectUrl: BASE_URL + '/subscription'
      })
       .then((res) => {
         if (res.data.isSuccess) {
          window.location.href = res.data.url;
       } else {
          toast.warning('در ذخیره بلیط امنیتی مشکلی پیش آمد، مجددا تلاش نمایید', { autoClose: 2000 })   
       }});
  };  

  useEffect(() => {
    if (handledRef.current) return;

    const searchParams = new URLSearchParams(location.search);
    const status = searchParams.get('status');
    const token = searchParams.get('token');
  
    if (status) {
      handledRef.current = true;
      handleCallback(status, token);
    }
  }, [location.search]);


const handleCallback = async (status, token) => {
  if (!status) return;
  if (status === 'done') {  
    api.post(BAZAAR_VERIFYPAYMENT, {
      checkout_token: token
    })
     .then((res) => {
       if (res.data.verifyIsSuccessStatusCode && res.status===200) {
          toast.success('پرداخت شما با موفقیت انجام شد', { autoClose: 1500 })
          // 🔁 رفرش دیتای صفحه
          fetchSubscriptions();
          // 🧹 پاک کردن querystring
          navigate(location.pathname, { replace: true });
     } else {
        toast.warning('پرداخت شما تایید نشد، لطفا مجددا تلاش نمایید', { autoClose: 2000 })
        navigate(location.pathname, { replace: true });   
     }});
  } else if(status !=='done' & status !== null) {
      toast.warning('پرداخت ناموفق،لطفا مجددا تلاش نمایید', { autoClose: 1500 }) 
      navigate(location.pathname, { replace: true });
  }
};



  return (
    <div className="container py-3" dir="rtl">
      {isLoading ? (
          <SpinnerWrapper>
            <PuffLoader color="green" loading={true} size={60} />
          </SpinnerWrapper>
        ) : (
          <>
            {/* Pay Button */}
            <div className="d-grid mb-4">
              <button className="btn btn-success btn-lg rounded-3" 
                      disabled={!canPayment} onClick={() => paymentOnline('person')}>
                پرداخت آنلاین
              </button>
              {!canPayment && (
                <small className="text-danger d-block mt-2">
                  به دلیل وجود اشتراک فعال، امکان پرداخت وجود ندارد
                </small>
              )}
            </div>

            <h6 className="fw-bold mb-3 text-secondary">تاریخچه تراکنش‌ها</h6>

            <div className="list-group">
              {transactions.map((item) => {
                const isOpen = openId === item.id;

                return (
                  <div key={item.id} className="mb-2">
                    {/* Card */}
                    <div
                      onClick={() => {
                        setSelectedTransaction(item);
                        setIsOpenBS(true);
                      }}                      
                      className={`${styles.transactionCard} d-flex align-items-center justify-content-between rounded-3 shadow-sm ${isOpen ? styles.activeCard : ''}`}
                      role="button"
                    >
                      {/* Arrow box */}
                      <div className={styles.arrowBox}>
                        ↑
                      </div>

                      {/* Content */}
                      <div className="flex-grow-1 px-3 d-flex justify-content-between align-items-center">
                        <div className="d-flex flex-column">
                          <div className={styles.title}>{item.payment==="۰" ? ("اشتراک یک ماهه"):("اشتراک یک ساله")}</div>
                          <div className={styles.subtitle}>اعتبار تا {item.expireDateTimeP}</div>
                        </div>
                        <div className="text-end">
                          <div className={styles.amount}>{item.payment} تومان</div>
                          <div className={styles.date}>{item.buyDateTimeP}</div>
                        </div>
                      </div>

                      {/* Chevron */}
                      <BsChevronLeft
                          className={`${styles.transition} ${isOpen ? styles.rotate : ''}`}
                          size={24} // اندازه آیکون، به جای fs-4
                          color="gray" // متناظر با text-muted
                      />
                    </div>

                    {/* Animated Details */}
                    {/* <div className={`collapse ${isOpen ? "show" : ""}`}>
                      <div className="card card-body border-0 pt-2">
                        <p className="small text-muted mb-2">{item.description}</p>
                        <Link
                          to={`/transactions/${item.id}`}
                          className="btn btn-outline-primary btn-sm w-100"
                        >
                          مشاهده جزئیات تراکنش
                        </Link>
                      </div>
                    </div> */}
                  </div>
                );
              })}

              {/* BottomSheet جزئیات تراکنش */}
              <BottomSheet isOpen={isOpenBS} onClose={() => setIsOpenBS(false)}>
                {selectedTransaction && (
                  <SubscriptionBS transaction={selectedTransaction} closeButtomSheetHandler={() =>
                    setIsOpenBS(false)
                  }/>
                )}
              </BottomSheet>
            </div>
          </>
      )}
    </div>
  );
};

export default Subscription;
